import * as React from "react";
import { Pagination, Grid , Card , Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom';


interface InterfaceProps {
  categories?: any;
}



export class CategoryList extends React.Component<InterfaceProps, {}> {
  constructor(props: any) {
    super(props);

    this.state = {
        activePage: 1
    };
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage })
  }

  public render() {
    const { categories }: any = this.props;
    const {activePage}: any = this.state;
    const categoryKeysArray = Object.keys(categories)
    return (
        <div>
          <Grid columns={4}>
                {!!categoryKeysArray  && categoryKeysArray.slice((activePage - 1) * 16, (activePage * 16) ).map(key => {
                  return (
                    <Grid.Column key={key}>
                      <Card as={Link} to={{ pathname: '/categories/'+ categories[key].id }}  color="teal">
                        <Card.Content style={{ backgroundColor: 'teal' , color: 'white'}}>
                             <h4>{categories[key].name}</h4>
                        </Card.Content>
                        <Card.Content extra>
                          <Icon name='tags' /> {categories[key].tags && categories[key].tags.length ? categories[key].tags.length : 4 } Tags  
                        </Card.Content>
                      </Card> 
                    </Grid.Column>
                )})}
          </Grid>
          <br />
          <div style={{ position: "fixed",
                        bottom: "20px",
                        left: "252px",
                        width: "calc(100% - 252px)"   
                      }} >
          { !!categoryKeysArray && categoryKeysArray.length > 0 &&
              <div style={{ textAlign:"center"}}>
                <Pagination  
                activePage={activePage}
                onPageChange={(e,{activePage}) => this.handlePaginationChange(e, {activePage})}
                totalPages={categoryKeysArray.length % 16 === 0 ? categoryKeysArray.length / 16 : Math.floor(categoryKeysArray.length / 16) + 1}
                />
            </div> 
          }
          </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pills/categories/categoriesList.tsx